import { chakra } from "@chakra-ui/react";
import React from "react";

import config from "configs/app";
import useApiQuery from "lib/api/useApiQuery";
import { HOMEPAGE_STATS } from "stubs/stats";
import { Image } from "toolkit/chakra/image";
import { Skeleton } from "toolkit/chakra/skeleton";

import TokenLogoPlaceholder from "./TokenLogoPlaceholder";

type Props = {
  isLoading?: boolean;
  className?: string;
  type?: "primary" | "secondary";
};

const NativeTokenIcon = ({ isLoading, className, type }: Props) => {
  const statsQueryResult = useApiQuery("general:stats", {
    queryOptions: {
      refetchOnMount: false,
      placeholderData: HOMEPAGE_STATS,
    },
  });

  if (isLoading || statsQueryResult.isPlaceholderData) {
    return <Skeleton borderRadius="base" loading className={className} />;
  }

  const primarySrc =
    statsQueryResult.data?.coin_image ||
    "https://bridge.morph.network/images/logo/ethereum2.svg";
  const src =
    type === "secondary"
      ? statsQueryResult.data?.secondary_coin_image
      : primarySrc;

  return (
    <Image
      className={className}
      borderRadius="base"
      src={src || undefined}
      alt={`${config.chain.currency.symbol} logo`}
      fallback={<TokenLogoPlaceholder />}
    />
  );
};

export default chakra(NativeTokenIcon);
